import React,{useState} from 'react';
import { Navbar, Header, Footer } from '../components';
import { Images } from '../constants'; 
import { ServiceData } from '../assets/Data';
import { ServiceCard } from '../components/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';



const Services = () => {
  const theme = useSelector((state)=> state.general.lightMode)
  const [searchQuery, setSearchQuery] = useState('');


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredServices = ServiceData.filter(service =>
    service.name.toLowerCase().includes(searchQuery.toLowerCase())
  );


  return (
    <div className={`flex flex-col relative ${theme ? 'bg-slate-100 ': 'bg-slate-900'} `}>
      <Header />
      <Navbar />
      <div className="relative">
        <img src={Images.SERVICE_BANNER} alt="Service Banner" className="h-auto w-full object-cover" />
        <div className="absolute inset-0 flex items-center justify-center">

          <div className="text-center text-white px-8 lg:w-3/5">
            <p className="lg:text-2xl poppins-regular text-[10px]">
              We specialize in crafting innovative and high-quality digital solutions to empower businesses and organizations to thrive in the digital age. With a focus on mobile app development for both Android and iOS platforms, as well as web application development, we deliver cutting-edge solutions tailored to meet your unique needs and objectives.
            </p>
          </div>

        </div>


        


      </div>
      <div className='justify-center items-center flex flex-col  py-4'>
          <p className={` ${theme ? 'text-black' : 'text-white'} poppins-regular`}>Elevating Your Digital Presence</p>
          <div className='bg-[#0C2D57] p-2 px-[50px] rounded-lg'><h1 className='text-white poppins-bold'>EXPLORE OUR SERVICES</h1></div>
        </div>
        <div className='flex justify-center items-center relative'>
      <input className='p-5 rounded-lg self-center w-4/5 m-2 lg:text-xl poppins-bold border-gray-400 border-2 ' value={searchQuery} 
          onChange={handleSearchChange}  placeholder='Search Services' />
      <div className='absolute right-16  lg:right-60 lg:top-7'>
        <FontAwesomeIcon icon={faSearch} color='black' size='2xl' />
        
      </div>
    </div>

        <div className='justify-center item-center flex py-10   '>
          <div className='flex flex-col lg:flex-row justify-between lg:w-4/5 lg:gap-10'>
          {filteredServices.slice(0,4).map((service, index) => (
            <ServiceCard index={index} name={service.name} description={service.description} image={service.image}/>

          ))}

          </div>
          
          

        </div>

        <div className='justify-center item-center flex pb-10  '>
          <div className='flex flex-col lg:flex-row justify-between lg:w-4/5 lg:gap-10'>
          {ServiceData.slice(4,8).map((service, index) => (
            <Link to={"https://forms.gle/pnDJZfMzXFZAxdSz7"}>
            <ServiceCard index={index} name={service.name} description={service.description} image={service.image}/>
            </Link>

          ))}

          </div>
          
          

        </div>

        <Footer/>
      
    </div>
  );
};

export default Services;
